import { render, staticRenderFns } from "./PlotLegendItemCollapsed.vue?vue&type=template&id=1146f6c3&"
import script from "./PlotLegendItemCollapsed.vue?vue&type=script&lang=js&"
export * from "./PlotLegendItemCollapsed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports